module.exports = __webpack_public_path__ + "static/media/imminence.72e1790c.svg";